import { render } from "./SignUpPropsCmp.vue?vue&type=template&id=54492228"
import script from "./SignUpPropsCmp.vue?vue&type=script&lang=js"
export * from "./SignUpPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__